<script >
import { ref, defineAsyncComponent, onBeforeMount } from 'vue-demi';
import '@futuweb/quote-charts/lib/H5QuoteCard/style/index.css';
const H5QuoteCard = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/H5QuoteCard'));
const __sfc_main = {};
__sfc_main.props = {
  stockId: Number || String,
  theme: Number,
  language: Number,
  platform: String
};
__sfc_main.setup = (__props, __ctx) => {
  const ftReport = window.FEGORender?.getFtReport?.();
  const props = __props;
  const {
    useCommonApi,
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    get
  } = useCommonApi('quote-index-card');
  const {
    isPreRender
  } = useEnv();
  const dataSource = ref(null);
  !isPreRender && props.stockId && onBeforeMount(async () => {
    try {
      const rsp = await get('get-quote-index', {
        stock_id: props.stockId,
        lang: props.language
      });
      dataSource.value = rsp;
    } catch (e) {
      console.error(e);
      dataSource.value = null;
    }
  });
  return {
    ftReport,
    dataSource
  };
};
__sfc_main.components = Object.assign({
  H5QuoteCard
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div class="quote-index-card">
        <H5QuoteCard
            v-if="dataSource"
            :ftReport="ftReport"
            :dataSource="dataSource"
            :theme="theme"
            :language="language"
            :platform="platform"
            class="quote-index-chart"
            pagePosition="fego"
        />
    </div>
</template>

<style lang="less" scoped>
.quote-index-chart {
    width: 100%;
    height: 100%;
}
</style>
